import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
import { buildAPIUrl, GR8PI_CREDENTIALS_STORE_KEY } from '../utils/Gr8piConfig';

const authMiddleware = new ApolloLink((operation, foreward) => {
  const credentialsSession = JSON.parse(localStorage.getItem(GR8PI_CREDENTIALS_STORE_KEY));

  if (credentialsSession) {
    const { accessToken } = credentialsSession;

    if (accessToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
    }
  }

  return foreward(operation);
});

const link = createUploadLink({
  uri: buildAPIUrl(),
  credentials: 'include',
});

const errorHandler = ({ operation, graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    // handle query/mutation error
    console.error(`Apollo graphql error ${JSON.stringify(operation)}`, graphQLErrors);
  }
  if (networkError) {
    // handle network error
    console.error(`Apollo network error ${JSON.stringify(operation)}`, graphQLErrors);
  }
};

const apollo = new ApolloClient({
  link: concat(authMiddleware, link),
  cache: new InMemoryCache(),
  onError: errorHandler,
});

export default apollo;
